import { getApiClient } from "@punchup/utils/apiRegistry";
import { logException } from "@punchup/sentry";
import { FeedbackListResponse } from "../../models/feedback";

export async function fetchFeedback(
  limit: number = 50,
  offset: number = 0
): Promise<FeedbackListResponse> {
  try {
    const searchParams = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString(),
    });

    const url = `/api/v2/internal/feedback?${searchParams.toString()}`;
    const response = await getApiClient().get<{ data: FeedbackListResponse }>(
      url
    );

    return response.data;
  } catch (error) {
    logException(error, {
      tags: {
        action: "fetchUserAppFeedback",
      },
    });
    throw error;
  }
}
